import { useEffect, useState } from "react";

const links = [
  { href: "#about", label: "About" },
  { href: "#book", label: "Book" },
  { href: "#consulting", label: "Consulting" },
  { href: "#speaking", label: "Speaking" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#0a0a0a]/95 backdrop-blur-sm border-b border-[#262626]" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <span className="w-7 h-7 bg-[#d92d20] flex items-center justify-center font-display font-extrabold text-sm">
            A
          </span>
          <span className="font-display font-extrabold tracking-tight text-[15px]">
            DR. CJ AVORY
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[13px] font-medium text-white/80 hover:text-white link-underline"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta-inquire"
          className="hidden md:inline-flex items-center gap-2 bg-[#d92d20] hover:bg-[#b91d13] text-white px-4 py-2 text-[12px] font-semibold tracking-[0.12em] uppercase transition-colors"
        >
          Request a Briefing
          <span aria-hidden>→</span>
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 border border-[#262626] flex items-center justify-center"
          aria-label="Toggle menu"
        >
          <span className="block w-4 h-px bg-white relative before:content-[''] before:absolute before:-top-1.5 before:left-0 before:w-4 before:h-px before:bg-white after:content-[''] after:absolute after:top-1.5 after:left-0 after:w-4 after:h-px after:bg-white" />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#262626] bg-[#0a0a0a]">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="text-sm font-medium text-white/85"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="mt-2 bg-[#d92d20] text-white px-4 py-3 text-xs font-semibold tracking-[0.12em] uppercase text-center"
            >
              Request a Briefing
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
